// extracted by mini-css-extract-plugin
export var container = "_4b-0";
export var disabled = "_4b-4";
export var fullWidth = "_4b-3";
export var lined = "_4b-1";
export var selected = "_4b-5";
export var tab = "_4b-2";